import React from 'react';
import AuthenticatedUserChip from '../../common/AuthenticatedUserChip';
import { useFormPalette } from './DynamicFormPrimitives';

/**
 * Form-specific wrapper: renders the shared chip with form palette
 * and fixed positioning in the top-right corner.
 */
export default function FormAuthenticatedUserChip() {
  const palette = useFormPalette();

  return (
    <AuthenticatedUserChip
      palette={palette}
      sx={{ position: 'fixed', top: 16, right: 16, zIndex: 100 }}
    />
  );
}
